// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"8281347c","312":"ac1ba654"}[chunkId] + ".chunk.js";
};